<script>
    import PriceCard from "../components/PriceCard.svelte";
    import PageTransition from "../components/PageTransition.svelte";

    import { onMount } from "svelte";

    onMount(() => {
    window.scrollTo(0, 0);
    });
</script>
<head>
    <link rel="canonical" href="https://fyrehost.net/valheim" />
    <link rel='stylesheet' href='global.css'>
	<link rel='stylesheet' href='build/bundle.css'>
    <style>
        html {
            scroll-behavior: smooth;
        }
        
        /* width */
        ::-webkit-scrollbar {
            width: 10px;
        }

        /* Track */
        ::-webkit-scrollbar-track {
            background: #3B375E;
            /*border-radius: 10px;*/
        }

        /* Handle */
        ::-webkit-scrollbar-thumb {
            background: #68638D;
            border-radius: 10px;
        }

        /* Handle on hover */
        ::-webkit-scrollbar-thumb:hover {
            background: #9992BF;
        }
    
    </style>
    <meta name="description" content="Cheap and Fast Valheim Server Hosting with Unlimited Slots and Lifetime Pricing!">
</head>
<div />
<PageTransition>
    <PriceCard
        name="Valheim"
        price="1"
        cpu="2 vCores"
        ram="1GB DDR4 RAM"
        paymentLink="https://buy.stripe.com/eVadSFbkBd7NfiE28i"
        paymentLinkDE="https://buy.stripe.com/7sIaGt3S91p52vS00r"
        paymentLinkUSE="https://buy.stripe.com/8wM4i51K1ebR6M88xc"
        paypalLink="https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-4TM2318201561810TMFKVJXI"
        paypalLinkDE="https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-5HH7993800964794SMGNOFTY"
        paypalLinkUSE="https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-67K13329TS800011UMG7JMCA"
        name2="Valheim"
        price2="2"
        cpu2="2 vCores"
        ram2="2 GB DDR4 RAM"
        paypalLink2="https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-8VA711896J605730VMFLGHSY"
        paypalLink2DE="https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-39A21021DU419150HMGNOFZA"
        paypalLink2USE="https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-9U936133VT122823NMG7JJTA"
        paymentLink2="https://buy.stripe.com/00gdSFbkB1p57Qc14f"
        paymentLink2DE="https://buy.stripe.com/dR615TdsJebRgmI28A"
        paymentLink2USE="https://buy.stripe.com/28o3e10FX8Rxdaw3cR"
        name3="Valheim"
        price3="3"
        cpu3="2 vCores"
        ram3="3GB DDR4 RAM"
        paypalLink3="https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-7DS75081YD872400PMFLGLUA"
        paypalLink3DE="https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-30351261M4199190UMGNOG7A"
        paypalLink3USE="https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-6PJ90107BW879224DMG7JJKA"
        paymentLink3="https://buy.stripe.com/cN26qd9ct9VBc6sbIU"
        paymentLink3DE="https://buy.stripe.com/bIYbKxdsJgjZ5I43cF"
        paymentLink3USE="https://buy.stripe.com/8wMeWJ74ld7NgmI3cQ"
        name4="Valheim"
        price4="4"
        cpu4="2 vCores"
        ram4="4GB DDR4 RAM"
        paypalLink4="https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-7AE11171XB771824RMFLGMQQ"
        paypaLink4DE="https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-30351261M4199190UMGNOG7A"
        paypalLink4USE="https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-7LJ70387TP998611WMG7JJAY"
        paymentLink4="https://buy.stripe.com/5kAg0NfARaZFgmI3cp"
        paymentLink4DE="https://buy.stripe.com/5kA7uh60h2t9daw6oS"
        paymentLink4USE="https://buy.stripe.com/7sIaGtfAR0l1c6s9Bd"
    />
</PageTransition>
